import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService } from '../services/base.service';


@Injectable()
export class DomainGuard  {
  constructor(
    private router: Router,
    private baseService: BaseService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.baseService.isCompany()) {
      const href = window.location.origin;
      window.location.href = href + '/companies';
      return false;
    }
    return true;
  }

}
